import React, { useState, useEffect, Fragment } from "react";
import { Card, Modal } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { rolecreate, roledetail, roleList } from "../../../services/master";

const RoleList = () => {
  const [filterProduct, setFilterProduct] = useState([]);
  const [Catid, setID] = useState(0);
  const [name, setName] = useState("");

  const [errorMessage, setErrorMessage] = useState("");
  useEffect(() => {
    funlist();
  }, []);

  function funlist() {
    setFilterProduct([]);
    roleList().then((res) => {
      if (res.status === true) {
        setFilterProduct(res.data);
      }
    });
  }
  const columnDefs = [
    {
      headerName: "Role",
      width: 670,
      field: "name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    // {
    //   headerName: "Actions",
    //   width: 180,
    //   field: "id",
    //   resizable: true,
    //   filter: false,
    //   // headerClass: "ag-center-aligned-header",
    //   cellRenderer: function (params) {
    //     return (
    //       <div className="text-center">
    //         <a
    //           onClick={() => viewshow(params.value)}
    //           className="btn-sm btn-info"
    //         >
    //           <i className="fa fa-edit"></i>
    //         </a>
    //       </div>
    //     );
    //   },
    // },
  ];



  const [show, setShow] = useState(false);
  function handleshow() {
    setID(0);
    setName("");

    setErrorMessage("");
    setShow(true);
  }

  function handleclose() {
    setID(0);

    setErrorMessage("");
    setShow(false);
  }

  function viewshow(vid) {
    setID(vid);
    setName("");
    setShow(true);

    setErrorMessage("");
    roledetail(vid).then((response) => {
      if (response.status === true) {
        setName(response.data.name);
      }
    });
  }

  function Submitage() {
    setErrorMessage("");

    if (name !== "") {
      const temp = new FormData();
      temp.append("name", name);
      temp.append("id", Catid);

      // stucategoryvalidate(temp).then((response) => {
      //   if (response.status === false) {
      //     setErrorMessage(response.message);
      //   } else {
      const tempData = new FormData();
      tempData.append("name", name);
      if (Catid != 0) {
        tempData.append("id", Catid);
      }
      rolecreate(tempData).then((response) => {
        if (response.status === true) {
          handleclose();
          funlist();
          toast.success(response.message);
        } else {
          // if(response.data.errors.length !== 0){
          //   for (const key in response.data.errors) {
          //     if (response.data.errors.hasOwnProperty(key)) {
          //         console.log(`${key}: ${response.data.errors[key][0]}`);
          //     }
          // }
          // }
          setErrorMessage(response.message);
        }
      });
      //   }
      // });
    } else {
      setErrorMessage("Please Enter Role");
    }
  }

  return (
    <Fragment>
      <div className="page-header reported-header">
        <div>
          <h2 className="main-content-title tx-24 mg-b-5">Role List</h2>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a>Settings</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Role
            </li>
          </ol>
        </div>
      </div>
      <Row className="row-sm mx-0 mt-3">
        <Col xxl={12} lg={12} md={12}>
          <Card className="custom-card overflow-hidden">
            <Card.Body>
              <div className="responsive">
                <div className="res-right">
                  <a
                    onClick={handleshow}
                    variant="success"
                    type="button"
                    className="btn my-1 me-2 btn-success tx-teko"
                  >
                    {" "}
                    Add
                  </a>
                </div>
                <div className="ag-theme-alpine ag-style">
                  <AgGridReact
                    columnDefs={columnDefs}
                    rowData={filterProduct}
                    pagination="true"
                    paginationPageSize="10"
                    sortingOrder={["asc", "desc"]}
                    suppressDragLeaveHidesColumns={true}
                  />
                </div>
              </div>

              <Modal show={show}>
                <Modal.Header>
                  {Catid === 0 ? (
                    <h4>Add Role</h4>
                  ) : (
                    <h4>Role Detail</h4>
                  )}
                </Modal.Header>
                <Modal.Body>
                  <Row className="row-sm mx-0">
                    <Col lg={12} md={12}>
                      <div className="form-group">
                        <label className="mb-2">
                          Role <span className="text-danger"> *</span>
                        </label>
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          placeholder="Enter Your Role"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </div>
                    </Col>

                    {errorMessage !== "" && (
                      <span className="text-danger">{errorMessage}</span>
                    )}
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  {Catid === 0 ? (
                    <a
                      onClick={Submitage}
                      className="btn btn-next btn-success"
                      style={{ float: "right" }}
                    >
                      Submit
                    </a>
                  ) : (
                    <a
                      onClick={Submitage}
                      className="btn btn-next btn-success"
                      style={{ float: "right" }}
                    >
                      Update
                    </a>
                  )}

                  <a
                    className="btn btn-next btn-secondary"
                    style={{ float: "right" }}
                    onClick={handleclose}
                  >
                    Close
                  </a>
                </Modal.Footer>
              </Modal>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default RoleList;
